import { AlertTriangle, Bot } from "lucide-react";
import { Modal } from "./Modals";

export default function SystemModal({ open, onClose, graph }) {
    if (!graph) return null;
    const systems = graph.nodes.filter((n) => n.type === "system");
    const flowCount = (id) => graph.flows.filter((f) => f.source === id || f.target === id).length;
    const damsFor = (id) => {
        const flowIds = graph.flows.filter((f) => f.source === id || f.target === id).map((f) => f.id);
        return graph.bottlenecks.filter((b) => b.status !== "avvisad" &&
            ((b.target_type === "flode" && flowIds.includes(b.target_id)) || (b.target_type === "nod" && b.target_id === id)));
    };

    return (
        <Modal open={open} onClose={onClose} title={`Systemöversikt – ${systems.length} system`} testid="system-modal" wide>
            <p className="text-xs text-slate-500 leading-relaxed mb-4">
                Alla system i kartläggningen, vad de ska bidra med och hur belastade de är. Redigera ändamål, kritikalitet
                och algoritmutsatthet via systemets detaljpanel på kartan.
            </p>
            <div className="space-y-2">
                {systems.length === 0 && (
                    <p className="text-sm text-slate-500">Inga systemnoder ännu – lägg till system via paletten i verksamhetsbilden.</p>
                )}
                {systems.map((s) => {
                    const dams = damsFor(s.id);
                    return (
                        <div key={s.id} data-testid={`system-row-${s.id}`} className="rounded-xl border border-border bg-abyss/40 p-3.5">
                            <div className="flex items-center justify-between gap-2 flex-wrap">
                                <span className="text-sm font-semibold text-slate-100">{s.label}</span>
                                <div className="flex items-center gap-2 flex-wrap">
                                    {s.algoritm_ai && (
                                        <span className="flex items-center gap-1 font-mono text-[9px] uppercase tracking-widest px-2 py-0.5 rounded-full border border-fuchsia-500/40 bg-fuchsia-500/10 text-fuchsia-300">
                                            <Bot className="w-3 h-3" />
                                            Algoritm/AI · utsatthet {s.utsatthet_algoritm || "?"}/5
                                        </span>
                                    )}
                                    {dams.length > 0 && (
                                        <span className="flex items-center gap-1 font-mono text-[9px] uppercase tracking-widest text-amber-400">
                                            <AlertTriangle className="w-3 h-3" /> {dams.length} dammar
                                        </span>
                                    )}
                                </div>
                            </div>
                            {s.andamal && <p className="text-xs text-slate-400 mt-1.5 leading-relaxed"><span className="text-slate-500">Ändamål:</span> {s.andamal}</p>}
                            <div className="flex items-center gap-4 mt-2">
                                <div className="flex items-center gap-1.5">
                                    <span className="font-mono text-[9px] uppercase tracking-widest text-slate-600">Kritikalitet</span>
                                    {s.kritikalitet ? (
                                        <div className="flex gap-0.5">
                                            {[1, 2, 3, 4, 5].map((v) => (
                                                <span key={v} className="w-3 h-1.5 rounded-full" style={{ background: v <= s.kritikalitet ? "#F472B6" : "#1E293B" }} />
                                            ))}
                                        </div>
                                    ) : <span className="text-[10px] text-slate-600">ej satt</span>}
                                </div>
                                <span className="font-mono text-[9px] uppercase tracking-widest text-slate-600">{flowCount(s.id)} flöden</span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </Modal>
    );
}
